import React, { useEffect, useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";

import { t } from "i18next";
import { isEmpty } from "lodash";
import { LuLogOut } from "react-icons/lu";
import OutsideClickHandler from "react-outside-click-handler";
const Menu = () => {
  const handleModalAccount = useContextSelector(AuthContext, (ctx) => {
    return ctx.handleModalAccount;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh
  );
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const setRegisterModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setRegisterModal;
  });
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const setMenuModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setMenuModal;
  });
  const setLoginModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLoginModal;
  });
  const lang = useContextSelector(AuthContext, (ctx) => {
    return ctx.lang;
  });
  const changeLanguage = useContextSelector(AuthContext, (ctx) => {
    return ctx.changeLanguage;
  });
  const [show, setShow] = useState(false);
  const [showList, setShowList] = useState(["account", "game"]);
  const navigate = useNavigate();
  const handle = (key) => {
    if (showList?.includes(key)) {
      setShowList((prev) => {
        return prev?.filter((res) => {
          return res !== key;
        });
      });
    } else {
      setShowList([...showList, key]);
    }
  };

  return (
    <div className="left-bar show">
      <div className="left-mask" style={{zIndex:"revert"}}/>{" "}
      <OutsideClickHandler onOutsideClick={() => setMenuModal(false)}>
        <div className="side-menu">
          <img
           src={"/assets/chorki/logo.svg"}
            alt="Logo"
            className="common-logo logo-img"
          />{" "}
          <div className="side-top-wrap">
            {isEmpty(user) ? (
              <div className="login-register">
                <div
                  onClick={() => {
                    setLoginModal(true);
                    setMenuModal(false);
                    setRegisterModal(false);
                  }}
                  className="login"
                >
                  <span className="txt">{t("LogIn")}</span>
                </div>{" "}
                <div
                  onClick={() => {
                    setLoginModal(false);
                    setMenuModal(false);
                    setRegisterModal(true);
                  }}
                  className="register"
                >
                  <span className="txt">{t("Register")}</span>
                </div>
              </div>
            ) : (
              <div className="logined-wrap">
                <div className="balance">
                  <span className="balance-amount">
                    ৳{Number(userCoins?.balance).toFixed(2) || 0}
                  </span>{" "}
                  <span onClick={amounutRefresh} className="balance-return">
                    <svg
                      data-v-08fe0fb5
                      aria-hidden="true"
                      className="svg-icon"
                    >
                      <use data-v-08fe0fb5 xlinkHref="#icon-refresh" />
                    </svg>
                  </span>
                </div>{" "}
                <div className="deposit-withdraw">
                  <div
                    onClick={() => handleModalAccount("invite")}
                    className="icon-wrap invite"
                  >
                    <div>{t("ShareEarn")}</div>
                  </div>{" "}
                  <div
                    onClick={() => handleModalAccount("deposit")}
                    className="icon-wrap deposit"
                  >
                    <div>{t("Deposit")}</div>
                  </div>{" "}
                  <div
                    onClick={() => navigate("/promotions")}
                    className="icon-wrap promo"
                  >
                    <div>{t("Promotion")}</div>
                  </div>
                </div>
              </div>
            )}
          </div>{" "}
          <div className="mc-menu-wrap">
            <div onClick={() => navigate("/promotions")} className="side-item">
              <img
                style={{ width: "23px", height: "23px" }}
                src={"/assets/Icon/promotion.svg"}
              />
              <span>{t("Promotion")}</span>
            </div>
            <div
              onClick={() => {
                setMenuModal(false);
                navigate("/affiliate-register");
              }}
              className="side-item"
            >
              <img
                style={{ width: "23px", height: "23px" }}
                src={"/assets/Icon/invite-friend.svg"}
              />
              <span>Affiliate</span>
            </div>
            <div
              onClick={() => handleModalAccount("rewardCenter")}
              className="side-item"
            >
              <img
                style={{ width: "23px", height: "23px" }}
                src={"/assets/Icon/reward-center.svg"}
              />
              <span>{t("RewardCenter")}</span>
            </div>
          </div>{" "}
          <div className="control-container">
            <div onClick={() => handle("game")} className="side-item active">
              <img
                style={{ width: "23px", height: "23px" }}
                src={"/assets/Icon/game-center.svg"}
              />
              <span>{t("GameCenter")}</span>{" "}
              <svg
                data-v-08fe0fb5
                aria-hidden="true"
                className="side-top-arrow svg-icon"
              >
                <use data-v-08fe0fb5 xlinkHref="#icon-side-top-arrow" />
              </svg>
            </div>{" "}
            <div
              className={`control-drop ${
                showList?.includes("game") ? "active" : ""
              }`}
            >
              <div className="control-drop__inner">
                <div
                  onClick={() => navigate("/rng?type=FC")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/slots.svg"}
                  />
                  <span>{t("Slots")}</span>
                </div>
                <div
                  onClick={() => navigate("/live")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/live-casino.svg"}
                  />
                  <span>{t("LiveCasino")}</span>
                </div>
                <div
                  onClick={() => navigate("/fish")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/fishing.svg"}
                  />
                  <span>{t("Fishing")}</span>
                </div>
                <div
                  onClick={() => navigate("/pvp")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/poker.svg"}
                  />
                  <span>{t("Poker")}</span>
                </div>
                <div
                  onClick={() => navigate("/sports")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/sports.svg"}
                  />
                  <span>{t("Sports")}</span>
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="control-container">
            <div onClick={() => handle("account")} className="side-item active">
              <img
                style={{ width: "23px", height: "23px" }}
                src={"/assets/Icon/account.svg"}
              />
              <span>{t("Account")}</span>{" "}
              <svg
                data-v-08fe0fb5
                aria-hidden="true"
                className="side-top-arrow svg-icon"
              >
                <use data-v-08fe0fb5 xlinkHref="#icon-side-top-arrow" />
              </svg>
            </div>{" "}
            <div
              className={`control-drop ${
                showList?.includes("account") ? "active" : ""
              }`}
            >
              <div className="control-drop__inner">
                {/* <div className="side-item child">
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/cashback.svg"}
                  />
                  <span>Cashback</span>
                </div> */}
                <div
                  onClick={() => handleModalAccount("vip")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/vip.svg"}
                  />
                  <span>{t("VIP")}</span>
                </div>
                <div
                  onClick={() => handleModalAccount("betting")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/betting-record.svg"}
                  />
                  <span>{t("BettingRecord")}</span>
                </div>
                <div
                  onClick={() => handleModalAccount("accountRecord")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/account-record.svg"}
                  />
                  <span>{t("AccountRecord")}</span>
                </div>
                {/* <div
                  onClick={() => handleModalAccount("account")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/security-center.svg"}
                  />
                  <span>{t("SecurityCenter")}</span>
                </div> */}
                <div
                  onClick={() => handleModalAccount("profitLoss")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/profit-loss.svg"}
                  />
                  <span>{t("ProfitAndLoss")}</span>
                </div>
                {/* <div
                  onClick={() => handleModalAccount("internal")}
                  className="side-item child"
                >
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={"/assets/Icon/mail.svg"}
                  />
                  <span>{t("Mailbox")}</span>
                </div> */}
              </div>
            </div>
          </div>{" "}
          <div onClick={() => navigate('/customer-support')}  className="side-item cs">
            <img
              style={{ width: "23px", height: "23px" }}
              src={"/assets/Icon/customer-service.svg"}
            />
            <span>{t("CustomerService")}</span>
          </div>{" "}
          <div className="lang-item">
            <div className="language-select">
              <div className="simple-select">
                <div onClick={() => setShow(true)} className="select-input">
                  <div className="selected-option">
                    <div className="language-selected">
                      <img
                        src={
                          lang == "en"
                            ? "https://images.6949393020.com//TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/US.svg"
                            : "https://images.6949393020.com//TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/BD.svg"
                        }
                        alt="EN"
                        loading="lazy"
                        className="flag-icon"
                      />{" "}
                      <span className="language-title">
                        {lang == "en" ? "English" : "বাংলা"}
                      </span>
                    </div>
                  </div>{" "}
                  <i className="arrow-icon down">
                    <svg
                      data-v-08fe0fb5
                      aria-hidden="true"
                      className="svg-icon"
                    >
                      <use data-v-08fe0fb5 xlinkHref="#icon-common-arrow" />
                    </svg>
                  </i>
                </div>{" "}
                <div
                  className="select-options"
                  style={{ display: show ? "flex" : "none" }}
                >
                  {" "}
                  <div
                    onClick={(e) => changeLanguage("bn")}
                    className={`select-option ${
                      lang == "bn" ? "selected" : ""
                    }`}
                  >
                    <img
                      src="https://images.6949393020.com//TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/BD.svg"
                      alt="BN"
                      loading="lazy"
                      className="flag-icon"
                    />
                  </div>
                  <div
                    onClick={(e) => changeLanguage("en")}
                    className={`select-option ${
                      lang == "en" ? "selected" : ""
                    }`}
                  >
                    <img
                      src="https://images.6949393020.com//TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/US.svg"
                      alt="EN"
                      loading="lazy"
                      className="flag-icon"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          {!isEmpty(user) && (
            <div onClick={() => logoutUser()} className="logout-item">
              <LuLogOut fill="unset" color="#47a3f3" className="svg-icon" />
              <span>{t("LogOut")}</span>
            </div>
          )}
          {/**/}
        </div>{" "}
      </OutsideClickHandler>
    </div>
  );
};

export default Menu;
